export default __webpack_public_path__ + "static/media/39_mobile.4fe685ec.jpg";